import { RootState } from '..';
import { IArea } from './types';

export const areasSelector = (state: RootState): IArea[] => state.area.data;
